export default __webpack_public_path__ + "static/media/004-medico.ef526873.png";